import type { BudgetDB } from "./db";
import { isDemoMode } from "./db";

export const DEMO_READONLY_EVENT = "budgetos-demo-readonly";

let seeding = false;

/** Allow DB writes briefly while seeding demo data on load. */
export async function withDemoSeed<T>(fn: () => Promise<T>): Promise<T> {
  seeding = true;
  try {
    return await fn();
  } finally {
    seeding = false;
  }
}

function blockWrite(): void {
  if (seeding || !isDemoMode) return;
  window.dispatchEvent(new CustomEvent(DEMO_READONLY_EVENT));
  throw new DemoReadOnlyError();
}

export class DemoReadOnlyError extends Error {
  constructor() {
    super("Demo mode is read-only");
    this.name = "DemoReadOnlyError";
  }
}

export function isDemoReadOnlyError(err: unknown): boolean {
  return err instanceof DemoReadOnlyError;
}

/** Block all IndexedDB mutations after demo seed (hosted demo is preview-only). */
export function installDemoReadOnlyGuard(db: BudgetDB): void {
  if (!isDemoMode) return;

  const tables = [
    db.categories,
    db.accounts,
    db.transactions,
    db.debts,
    db.sinkingFunds,
    db.netWorthLogs,
  ] as const;

  for (const table of tables) {
    table.hook("creating", () => {
      blockWrite();
    });
    table.hook("updating", () => {
      blockWrite();
    });
    table.hook("deleting", () => {
      blockWrite();
    });
  }
}
